import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-divider"},[_c(VImg,{staticClass:"home-divider-img",attrs:{"lazy-src":require("../../../public/img/photos/rf-divisor-b.png"),"src":require("../../../public/img/photos/rf-divisor-b.png"),"max-height":"155"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }